import { render, staticRenderFns } from "./MovePresentations.vue?vue&type=template&id=4b6c78c9&scoped=true&"
import script from "./MovePresentations.vue?vue&type=script&lang=js&"
export * from "./MovePresentations.vue?vue&type=script&lang=js&"
import style0 from "./MovePresentations.vue?vue&type=style&index=0&id=4b6c78c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6c78c9",
  null
  
)

export default component.exports